import React from "react";
import PropTypes from "prop-types";
import {
  COMPANY_STATUS_ACTIONS,
  COMPANY_STATUS_IDS,
  COMPANY_STATUS_LABELS,
  PageHeightAuto,
  isCompanyActivated,
  notifyError,
} from "../../../../components/Utils";
import BasicDataForm from "./BasicDataForm";
import StatusForm from "../../../../components/StatusForm";
import { InputText, Label } from "../../../../components/Inputs";

function ContractorForm({
  forwardedRef,
  className = "",
  model = {},
  types,
  disabled,
  userCompany,
  getCompany,
  namePrefix = "contractor-",
}) {
  const basicDataFormRef = React.useRef(null);
  const statusDataFormRef = React.useRef(null);

  const validate = React.useCallback(
    (noValidate) => {
      const statusData = statusDataFormRef.current.getModel();
      let basicData = basicDataFormRef.current.getModel(noValidate);
      if (!noValidate && !basicData) {
        notifyError({
          summary: "Subunternehmen verwalten",
          detail: `Das Subunternehmen konnte nicht gespeichert werden. Bitte Ihre Eingaben überprüfen.`,
        });
        return window.scrollTo(0, basicDataFormRef.current.offsetTop);
      }
      basicData = basicData || {
        name: "",
        type: "",
        address: {},
        contractGivers: [],
      };
      const { name, type_id, address } = basicData;
      // const { id, index, activeEmployees, totalEmployees } = model;
      const newModel = {
        // id,
        // index,
        // activeEmployees,
        // totalEmployees,
        ...model,
        name,
        type_id,
        address,
        status_id: statusData.status_id,
      };
      const company = getCompany ? getCompany() : null;
      // console.log(">> Parent Company:", company);
      if (company && company.id) {
        newModel.parentId = company.id;
      }
      return newModel;
    },
    [model, getCompany],
  );

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  const getData = React.useCallback(() => getModel(true), [getModel]);
  React.useImperativeHandle(forwardedRef, () => ({
    getModel,
    getData,
  }));

  return (
    <div className={`${className}`} style={{ minHeight: "100px" }}>
      <PageHeightAuto id="basisdaten" className="w3-border margin-top pad-big">
        <div className="w3-row neg-margin-lr">
          <div className="w3-col s6 pad-lr">
            <h3 className="no-margin-top">Allgemeine Daten</h3>
          </div>
          <div className="w3-col s6 pad-lr">
            <StatusForm
              ref={statusDataFormRef}
              className="status-form w3-right-"
              model={{ status_id: model.status_id }}
              statusIds={COMPANY_STATUS_IDS}
              statusLabels={COMPANY_STATUS_LABELS}
              statusActions={COMPANY_STATUS_ACTIONS}
              objectTitle="das Subunternehmen"
              disabled={
                disabled ||
                (model.activeEmployees > 0 && isCompanyActivated(model))
              }
              namePrefix={namePrefix}
            />
          </div>
          <BasicDataForm
            ref={basicDataFormRef}
            className="pad-lr"
            model={model}
            types={types}
            userCompany={userCompany}
            disabled={disabled}
            namePrefix={namePrefix}
          />
        </div>
        <div className="w3-row neg-margin-lr">
          <div className="w3-col s6 pad-lr pad-top form-group-item">
            <Label htmlFor={`${namePrefix}schulungsportalId`}>
              {`ID Schulungsportal`}
            </Label>
            <InputText
              id={`${namePrefix}schulungsportalId`}
              data-test-id={`${namePrefix}schulungsportalId`}
              className={`w3-block w3-border pad round-input`}
              value={model.schulungsportalId || ""}
              readonly
            />
          </div>
        </div>
      </PageHeightAuto>
    </div>
  );
}

ContractorForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  types: PropTypes.array,
  userCompany: PropTypes.object,
  getCompany: PropTypes.func,
  disabled: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <ContractorForm {...props} forwardedRef={ref} />
));
